//@ts-nocheck
import React, { useState, useCallback } from "react";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Checkbox, Popover } from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
const icon = (
    <CheckBoxOutlineBlankIcon fontSize="small" style={{ borderRadius: 4 }} />
);
const checkedIcon = (
    <CheckBoxIcon
        style={{ backgroundColor: "#FF5C39", color: "#fff", borderRadius: 4 }}
        fontSize="small"
    />
);

export default function MoreFilter({ filters, setReportedVacancy, setGeneralOccupancy, setPriceRange, setBeds, setBaths, setLotSize, setSquareFootage, setYearBuilt, priceRange, beds, baths, lotSize, squareFootage, yearBuilt, generalOccupancy, reportedVacancy }) {

    // Handler for occupancy state changes
    const handleOccupancyChange = (label, value) => {
        if (label === "Reported Vacant") {
            setReportedVacancy((prev) => !prev);
        } else {
            setGeneralOccupancy((prev) =>
                prev.includes(value)
                    ? prev.filter((item) => item !== value)
                    : [...prev, value]
            );
        }
    };
    const handleRangeChange = (filter, value) => {
        if (filter === "Beds") {
            setBeds(value);
        } else if (filter === "Baths") {
            setBaths(value);
        }
    };
    const squareFootageConverter = (value) => (parseInt(value) <= 100 ? parseInt(value) * 43560 : parseInt(value))
    const handleLotSizeChange = (type, value) => {
        const condition = type === "min" ? squareFootageConverter(value) > squareFootageConverter(lotSize.max) : squareFootageConverter(lotSize.min) > squareFootageConverter(value)
        if (condition) {
            if (type === "min") {
                setLotSize((prev) => ({
                    ...prev,
                    min: "",
                }))
            }
            else {
                setLotSize((prev) => ({
                    ...prev,
                    min: "",
                    [type]: value, // 'type' will be either 'min' or 'max'
                }))
            }
        } else {
            setLotSize((prev) => ({
                ...prev,
                [type]: value, // 'type' will be either 'min' or 'max'
            }));
        }
    };

    const renderFilter = useCallback((filterKey, filter) => {
        switch (filter.value) {
            case "Number":
                if (filter.label === "Lot Size" || filter.label === "Year Built" ||filter.label === "Square Footage" ) return
                if (filter.label === "Lot Size") {
                    // return (
                    //     <div key={filter.id} className="mb-4 grid grid-cols-11 items-center justify-center">
                    //         <label className="block col-span-11 text-sm font-medium text-gray-700 mb-2">{filter.label}</label>
                    //         <select
                    //             value={lotSize.min}
                    //             onChange={(e) => handleLotSizeChange("min", e.target.value)}
                    //             className="block px-3 py-2 col-span-5 text-[#9FA4AB] bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    //         >
                    //             {filter.children?.map((child) => (
                    //                 <option className="text-gray-700" key={child.id} value={child.value}>
                    //                     {child.label}
                    //                 </option>
                    //             ))}
                    //         </select>
                    //         <p className="col-span-1 text-center">to</p>
                    //         <select
                    //             value={lotSize.max}
                    //             onChange={(e) => handleLotSizeChange("max", e.target.value)}
                    //             className="block col-span-5 px-3 py-2 text-[#9FA4AB] bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    //         >
                    //             {filter.children?.map((child, index) => (
                    //                 index === 0 ? <option key={child.id} value={"No Maximum"}>
                    //                     No Maximum
                    //                 </option> :
                    //                     <option key={child.id} value={child.value}>
                    //                         {child.label}
                    //                     </option>
                    //             ))}
                    //         </select>
                    //     </div>
                    // );
                }
                return (
                    <div key={filterKey} className="mb-3">
                        <label className="block text-sm font-medium text-gray-700 mb-2">{filter.label}</label>
                        <div className="flex space-x-2 items-center ">
                            <input
                                type={filterKey === "Year Built" ? "text" : "number"}
                                placeholder={filterKey === "Year Built" ? "YYYY" : "No Minimum"}
                                value={
                                    filterKey === "Year Built" ? yearBuilt.min :
                                        filterKey === "Price Range" ? priceRange.min : squareFootage.min
                                }
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (filterKey === "Year Built") {
                                        // Allow clearing the input (empty value)
                                        if (value === "") {
                                            setYearBuilt({ ...yearBuilt, min: value });
                                        } else if (value.length <= 4 && /^[0-9]{0,4}$/.test(value)) {
                                            setYearBuilt({ ...yearBuilt, min: value });
                                        }
                                    } else if (value >= 0) {
                                        // Ensure non-negative values for Price Range and Square Footage
                                        if (filterKey === "Price Range") {
                                            setPriceRange({ ...priceRange, min: value });
                                        } else {
                                            setSquareFootage({ ...squareFootage, min: value });
                                        }
                                    }
                                }}
                                min="0" // For Price Range and Square Footage, ensure values can't be negative
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                            />
                            <span className="">to</span>
                            <input
                                type="number"
                                placeholder={filterKey === "Year Built" ? "YYYY" : "No Maximum"}
                                value={
                                    filterKey === "Year Built" ? yearBuilt.max :
                                        filterKey === "Price Range" ? priceRange.max : squareFootage.max
                                }
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (filterKey === "Year Built") {
                                        // Allow clearing the input (empty value)
                                        if (value === "") {
                                            setYearBuilt({ ...yearBuilt, max: value })
                                        } else if (value.length <= 4 && /^[0-9]{0,4}$/.test(value)) {
                                            setYearBuilt({ ...yearBuilt, max: value })
                                        }
                                    } else if (value >= 0) {
                                        // Ensure non-negative values for Price Range and Square Footage
                                        if (filterKey === "Price Range") {
                                            setPriceRange({ ...priceRange, max: value });
                                        } else {
                                            setSquareFootage({ ...squareFootage, max: value });
                                        }
                                    }
                                }}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                            />
                        </div>
                    </div>
                );

            case "Range":
                return (
                    <div key={filter.id} className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-2">{filter.label}</label>
                        <div className="flex space-x-2 shadow-sm ">

                            {filter.label === "Beds" ? ["Any", 1, 2, 3, 4, 5, 6].map((value, index) => (
                                <button
                                    key={index} onClick={() => handleRangeChange("Beds", value)}
                                    className={`px-2 py-1 flex-1 h-10 w-6 border rounded-md ${beds === value
                                        ? "bg-[#FF5C39] text-white"
                                        : "bg-white text-black hover:bg-gray-100"
                                        } focus:outline-none`}
                                >
                                    {value}
                                </button>
                            )) :

                                ["Any", 1, 2, 3, 4].map((value, index) => (
                                    <button
                                        key={index}
                                        onClick={() => handleRangeChange("Baths", value)}
                                        className={`px-2 py-1 flex-1 h-10 border rounded-md ${baths === value
                                            ? "bg-[#FF5C39] text-white"
                                            : "bg-white text-black hover:bg-gray-100"
                                            } focus:outline-none`}
                                    >
                                        {value}
                                    </button>
                                ))}
                        </div>
                    </div>
                );

            case "Occupancy":
                return (
                    <div key={filter.id} className="mb-4 grid grid-cols-2" >
                        <label className="block col-span-2  font-medium text-[#3B3B3B] mb-2">{filter.label}</label>
                        {filter.children.map((child, index) => (
                            <div key={child.id} className={`${index > 1 ? "col-span-2" : "col-span-1"} flex items-center cursor-pointer p-2`} >
                                <Checkbox
                                    sx={{ p: 0, mr: 1 }}
                                    icon={icon}
                                    checkedIcon={checkedIcon}// Using sx for margin
                                    name={child.label}
                                    onChange={() => handleOccupancyChange(child.label, child.value)}
                                    checked={
                                        child.label === "Reported Vacant"
                                            ? reportedVacancy
                                            : generalOccupancy.includes(child.value)
                                    }

                                />
                                <label
                                    htmlFor={`filter-${child.id}`}
                                    onClick={() => handleOccupancyChange(child.label, child.value)}
                                    className="font-medium text-gray-700 cursor-pointer"
                                >
                                    {child.label}
                                </label>
                                {/* <span className="ml-2">
                                    <svg
                                        className='cursor-pointer'
                                        stroke="#FF5C39" fill="#FF5C39" strokeWidth="0" viewBox="0 0 16 16"
                                        height="20px" width="20px" xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path fillRule="evenodd" d="M8 15A7 7 0 108 1a7 7 0 000 14zm0 1A8 8 0 108 0a8 8 0 000 16z" clipRule="evenodd"></path>
                                        <path d="M8.93 6.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588z"></path>
                                        <circle cx="8" cy="4.5" r="1"></circle>
                                    </svg>
                                </span> */}
                            </div>
                        ))}
                    </div>
                );

            default:
                return null;
        }
    }, [priceRange, beds, baths, lotSize, squareFootage, yearBuilt, generalOccupancy, reportedVacancy]);
    const orderedFilters = useCallback(() => {
        const occupancyFilter = Object.entries(filters).filter(([key, filter]) => filter.label === "Occupancy");
        const otherFilters = Object.entries(filters).filter(([key, filter]) => filter.label !== "Occupancy");
        return [...occupancyFilter, ...otherFilters];
    }, [filters]);

    return (
        orderedFilters().map(([key, filter]) => renderFilter(key, filter))
    );
}
